import { z } from 'zod/v4';

export const partnerIntegrationCredentialsSchema = z.object({
  displayName: z.string().nullable(),
  propertyName: z.string().nullable(),
  protected: z.boolean().nullable(),
  description: z.string().nullable(),
});

export type PartnerIntegrationCredentials = z.infer<
  typeof partnerIntegrationCredentialsSchema
>;
